import { SvgIcon } from '@mui/material';
import React from 'react';

const MPXXXLutzIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        id="XXXLutz"
        data-name="XXXLutz"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 43 21"
        strokeWidth={0}
        fill="currentColor"
      >
        <title>XXXLutz</title>
        <path d="M7 7H21.6532V14H7V7Z" fill="white" />
        <path d="M21.651 7H36V14H21.651V7Z" fill="#E20015" />
        <path
          d="M35.7961 7H7V14H36V7H35.7961ZM35.7961 13.7946H7.20391V7.20543H35.7961V13.7946Z"
          fill="black"
        />
        <path
          d="M28.5419 12.5276H27.6317V12.2141C27.3897 12.6052 25.502 13.0084 25.502 11.2843V9.40952H26.4475V11.218C26.4475 11.9721 27.5964 11.9816 27.5964 11.0798V9.40952H28.5419V12.5276ZM29.301 11.281C29.301 12.5659 30.3224 12.6119 31.022 12.5294V11.7442C30.7148 11.7442 30.2465 11.8005 30.2465 11.3595V10.1905H31.022V9.40952H30.2465V8.45721H29.301V11.281ZM31.7491 11.9715V12.5276H34.3645V11.7466H32.9157L34.3452 9.96587L34.3461 9.40952H31.7434V10.1908H33.2051L31.7491 11.9715Z"
          fill="white"
        />
        <path
          d="M11.0978 12.5276L10.3184 11.2402L9.53901 12.5276H8.392L9.69639 10.462L8.43671 8.45752H9.57556L10.3187 9.68404L11.0618 8.45752H12.2007L10.941 10.462L12.2454 12.5276H11.0978ZM20.92 12.5276L19.6156 10.462L20.8753 8.45752H19.7364L18.9933 9.68404L18.2502 8.45752H17.1113L18.371 10.462L17.0666 12.5276H18.2136L18.993 11.2402L19.7724 12.5276H20.92ZM16.5948 12.5276L15.2904 10.462L16.5501 8.45752H15.4112L14.6681 9.68404L13.925 8.45752H12.7861L14.0458 10.462L12.7414 12.5276H13.8884L14.6678 11.2402L15.4472 12.5276H16.5948ZM24.8848 11.5999H23.536V8.46452H22.544V12.5276H24.8848V11.5999Z"
          fill="#00151D"
        />
      </svg>
    </SvgIcon>
  );
};

export default MPXXXLutzIcon;
